import { SavedAddress } from 'domains/savedAddresses';

export const formatAddressPrimary = (item: SavedAddress): string => {
  if (item.city && item.address) {
    const cityPrefix = item.city.startsWith('г.')
      ? item.city
      : `г. ${item.city}`;
    if (item.address.includes(item.city) || item.address.startsWith('г.')) {
      return item.address;
    }
    return `${cityPrefix} ${item.address}`;
  }
  return item.address;
};

export const formatAddressDetails = (
  item: SavedAddress,
  labels: {
    entrance: string;
    floor: string;
    apartment: string;
    housing: string;
  },
): string => {
  const parts: string[] = [];
  if (item.entrance) parts.push(`${labels.entrance} ${item.entrance}`);
  if (item.floor) parts.push(`${labels.floor} ${item.floor}`);
  if (item.apartment) parts.push(`${labels.apartment} ${item.apartment}`);
  if (item.housing) parts.push(`${labels.housing} ${item.housing}`);
  return parts.join(', ');
};

export const isSameDeliveryAddress = (
  saved: SavedAddress,
  current: {
    cityId: string;
    street: string;
    house: string;
    apartment: string | null;
  } | null,
): boolean => {
  if (!current) return false;
  return (
    saved.cityId === current.cityId &&
    saved.street === current.street &&
    saved.house === current.house &&
    (saved.apartment || null) === (current.apartment || null)
  );
};
